<script>
    import AppCostCalc from "../components/AppCostCalc";
    import MobileAppCostCalc from "../components/MobileAppCostCalc";
    import { isMobile } from "mobile-device-detect";
    export default {
        functional: true,
        render: (h, context) => {
            if(isMobile) {
                return h(MobileAppCostCalc, context.data, context.children)
            } else {
                return h(AppCostCalc, context.data, context.children)
            }
        }
    }
</script>